export default class Clock {
    static sleep = (sec) => new Promise(resolve => setTimeout(resolve, sec * 1000));
}
